import { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useParams } from "react-router-dom";

import { Worker, Viewer, TextDirection, LocalizationContext } from '@react-pdf-viewer/core';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import { searchPlugin } from '@react-pdf-viewer/search';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { highlightPlugin } from "@react-pdf-viewer/highlight";

import { MdDraw, MdOutlineZoomInMap, MdSearch, MdZoomIn, MdZoomOut } from 'react-icons/md';

import { GET, Loader } from '../../inc/Fetch';
import { Config } from '../../inc/Config';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/search/lib/styles/index.css';

import './css/newBook.css';

import Paging from './paging';
import { useContext } from 'react';
import { AppContext } from '../../Context';
import { Img } from '../../components/Elements';
import { MainUserMenu } from '../../components/Menu';
import Draw from './Draw';
import Login from '../popups/Login';
import SearchUI from './Search';
import { LuSearch } from 'react-icons/lu';
import { Helmet } from 'react-helmet';
import { GoTasklist } from 'react-icons/go';

export default function NewBook() {

    const drawingsRef = useRef({});
    const viewerRef = useRef();
    const params = useParams();
    const GAP = 15;

    const [pageLoad, setpageLoad] = useState(true);
    const [data, setdata] = useState({});
    const [quiz, setquiz] = useState([]);
    const [page, setpage] = useState(1);
    const [zoom, setzoom] = useState(1.3);
    const [showDraw, setshowDraw] = useState(false);
    const [pdfIndex, setPdfIndex] = useState([]);

    const [searchActive, setsearchActive] = useState(false);

    const {success, userinfo, showQuiz, languageText, loginForm} = useContext(AppContext);
    const [open, setopen] = success;
    const [showQuizD, setshowQuizD] = showQuiz;
    const [text, settext] = languageText;
    const [user, setuser] = userinfo;
    const [openLogin, setopenLogin] = loginForm;
    

    const pageNavigationPluginInstance = pageNavigationPlugin();
    const zoomPluginInstance = zoomPlugin();

    const searchPluginInstance = searchPlugin();
    const { Search } = searchPluginInstance;


    const arabicLocale = {
        // You can customize these strings to your liking
        'core': {
            'search': 'بحث',
            'zoom': 'تكبير/تصغير',
            'previousPage': 'الصفحة السابقة',
            'nextPage': 'الصفحة التالية',
        },
        // Add other plugin translations here if needed
    };

    const highlightPluginInstance = highlightPlugin({
        onTextLayerRender: ({ pageIndex, textLayerDiv }) => {
            const page = data[pageIndex];
            if (!page || !keyword) return;

            textLayerDiv.querySelectorAll('span').forEach((span) => {
                if (span.textContent.includes(keyword)) {
                    const rect = span.getBoundingClientRect();
                    highlightPluginInstance.addHighlight({
                        pageIndex,
                        rects: [
                            { x1: rect.left, y1: rect.top, x2: rect.right, y2: rect.bottom }
                        ],
                        color: 'yellow',
                    });
                }
            });
        },
    });

    const handleDocumentLoad = async (e) => {
        const pdf = e.doc;
        const pages = [];

        for (let i = 1; i <= pdf.numPages; i++) {
            const page = await pdf.getPage(i);
            const textContent = await page.getTextContent();

            const text = textContent.items
                .map((item) => item.str)
                .join(" ");

            pages.push({
                pageIndex: i - 1,
                text,
            });
        }

        setPdfIndex(pages);
    };
    

    async function loadData() { 

        setpageLoad(true);

        let res = await GET(`books/viewOne/${params?.id}`);
        if (res?.book?.book?.length) {
            setdata(res?.book);
            setquiz(res?.quiz);
        } else {
            setdata({});
            setquiz([]);
        }

        setpageLoad(false);
    }
    useEffect(() => {
        loadData();
    }, []);
    
    useEffect(() => {
        zoomPluginInstance.zoomTo(zoom);
    }, [zoom]);

    useEffect(() => {
        if (!showDraw) {
            let body = viewerRef?.current?.querySelector('.pdfBookBox .rpv-core__inner-pages');
            body?.classList.remove("noScroll");
        }
    }, [showDraw]);

    if (pageLoad) return <Loader />

    if (!data?._id) return;
    
    const pageLayout = {
        buildPageStyles: () => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }),

        transformSize: ({ size }) => ({
            width: size.width, 
            height: size.height + GAP,
        }),
    };  
    
    function openFullscreen() {

		const fullScreenCk = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;

		var elem = document.documentElement;

		if (!fullScreenCk) {
			if (elem.requestFullscreen) {
				elem.requestFullscreen();
			} else if (elem.webkitRequestFullscreen) {
				elem.webkitRequestFullscreen();
			} else if (elem.msRequestFullscreen) {
				elem.msRequestFullscreen();
			}
		} else {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			}
		}
	}
    

    return (
        <LocalizationContext.Provider value={{ l10n: arabicLocale }}>
        <Helmet>
            <title>{data?.name?.name}</title>
            <meta name="description" content={data?.description} />
        </Helmet>

        {openLogin && <Login setopen={setopenLogin} open={openLogin} />}
        <nav className='bookHeaderBox'>
            <ul className='right'>
                <a href='#' onClick={openFullscreen}><MdOutlineZoomInMap /></a>
                <a href='#' onClick={() => setzoom(zoom + 0.2)}><MdZoomIn /></a>
                <a href='#' onClick={() => setzoom(zoom - 0.2)}><MdZoomOut /></a>
                {user?.userinfo?._id && <a href='#' className={searchActive ? 'active' : ''} onClick={() => setsearchActive(!searchActive)}><MdSearch /></a>}
            </ul>

            <h1>{data?.name?.name}</h1>

            <div className='left'>
                {!user?.userinfo?._id ? 
                    <b><a href='#' style={{color:"#fff"}} onClick={() => setopenLogin(true)}>مرحبا, انت زائر</a></b>
                :
                    <div className='outterUserBox'>
                        <a href='#' className='mainLink'><Img src={`img/40x40${user?.userinfo?.img}`} />{user?.userinfo?.name}</a>
                        <MainUserMenu />
                    </div>
                }
            </div>
        </nav>
        
        <div ref={viewerRef} className='bookViewBox'>
            
            <Paging page={page} plugin={pageNavigationPluginInstance} />

            {searchActive && <SearchUI
                data={pdfIndex}
                plugin={pageNavigationPluginInstance}
                searchPluginInstance={searchPluginInstance}
            />}
            
            <Worker 
                workerUrl="/pdf.worker.min.js"
                // cMapUrl="https://unpkg.com/pdfjs-dist@3.4.120/cmaps/"
                // cMapPacked={true}
            >
                
                <Viewer 
                    theme={{
                        // direction: TextDirection.RightToLeft,
                    }}
                    // characterMap={{
                    //     isCompressed: true,
                    //     url: 'https://unpkg.com/pdfjs-dist@3.4.120/cmaps/',
                    // }}
                    plugins={[ pageNavigationPluginInstance, zoomPluginInstance, searchPluginInstance, highlightPluginInstance ]}
                    defaultScale={zoom}
                    fileUrl={`${Config?.imgUrl}${data?.book[0]}`} 
                    pageLayout={pageLayout}
                    onPageChange={(e) => {
                        setpage(e?.currentPage + 1);
                    }}

                    renderPage={(props) => {

                        let catID = false;
                        let classesID = false;
                        let quizData = quiz?.find(q => q?.page_number == props?.pageIndex + 1);
                        if (quizData?._id) {
                            catID = quizData?.cats[0]?._id;
                            classesID = quizData?.classes[0];
                        }

                        if (user?.userinfo?._id) {
                            return (
                                <>
                                    <div className='rightRichOptions'>
                                        {props?.pageIndex ? <a onClick={() => setshowDraw(props?.pageIndex)} title='رسم' className='drawBtn'><MdDraw /></a>: null}
                                        {quizData?._id ? <a target='_blank' href={`/cat/${classesID}/${catID}/${quizData?._id}`} title='المهمة المحوسبة' className='taskBtn'><GoTasklist /></a>: null}
                                    </div>
                                    {showDraw == props?.pageIndex && <Draw drawingsRef={drawingsRef} setshowDraw={setshowDraw} show={showDraw} />}
                                    {props.canvasLayer.children}
                                    {props.annotationLayer.children}
                                    {props.textLayer.children}
                                </>
                            );
                        } else {

                            if (props?.pageIndex <= 10) {
                                return (
                                    <>
                                        {props.canvasLayer.children}
                                        {props.annotationLayer.children}
                                        {props.textLayer.children}
                                    </>
                                );
                            } else {
                                return (
                                    <>
                                        <div className='nopagesText'>قم بتسجيل الدخول لمتابعة القراءة</div>
                                        {props.annotationLayer.children}
                                    </>
                                );
                            }
                        }
                        
                    }}
                    onDocumentLoad={handleDocumentLoad}
                />
            </Worker>
        </div>
        </LocalizationContext.Provider>

    )
}
